module.exports = __webpack_public_path__ + "static/media/locationmap-bg.d754122b.png";